export const appSettings = {
  title: 'App Settings',
  description:
    'Firestore appSettings documents read by the Overhear mobile app at runtime.',
  loadError: 'Failed to load app settings.',
  versionSection: {
    title: 'Force update (appVersion)',
    description:
      'When the installed app version is below minimumVersion, users see a blocking update screen before the app loads. Leave minimum version empty to allow all versions.',
    minimumVersion: 'Minimum app version',
    minimumVersionHelper: 'e.g. 3.4.3 — matches version in the mobile app.json / store release',
    minimumIosBuildNumber: 'Minimum iOS build number',
    minimumIosBuildNumberHelper: 'Optional — only enforced when version matches minimum',
    minimumAndroidVersionCode: 'Minimum Android version code',
    minimumAndroidVersionCodeHelper: 'Optional — only enforced when version matches minimum',
    message: 'Update screen message',
    messageHelper: 'Optional custom message on the force-update screen',
    iosStoreUrl: 'iOS App Store URL',
    iosStoreUrlHelper: 'Optional override — defaults to the Overhear App Store link',
    androidStoreUrl: 'Google Play URL',
    androidStoreUrlHelper: 'Optional override — defaults to the Overhear Play Store link',
    save: 'Save version settings',
    saved: 'Version settings saved.',
  },
  busPairingSection: {
    title: 'Bus pairing (busPairing)',
    description:
      'Distances used for live bus pairing prompts and sync on the Overhear map.',
    pairingPromptDistanceM: 'Pairing prompt distance (m)',
    pairingPromptDistanceMHelper: 'User GPS to live bus — default 140 m',
    pairingSyncMaxDistanceM: 'Pairing sync max distance (m)',
    pairingSyncMaxDistanceMHelper: 'Max drift before pairing sync breaks — default 120 m',
    save: 'Save bus pairing settings',
    saved: 'Bus pairing settings saved.',
  },
  wanderNotificationsSection: {
    title: 'Wander notifications (wanderNotifications)',
    description:
      'Delay after starting a wander before the “Ready to Wander again?” push is scheduled. Fractional hours are allowed (e.g. 0.5 = 30 minutes).',
    nextWanderNotificationHours: 'Hours until next wander reminder',
    nextWanderNotificationHoursHelper:
      'Written to appSettings/wanderNotifications — default 1 hour when missing or invalid',
    save: 'Save wander notification settings',
    saved: 'Wander notification settings saved.',
  },
};
